export default function Zoom ({ className = '' }) {
  return (
    <svg viewBox="0 0 24 24"
      height="16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="1.5"
    ><path d="M6 17.998L0.75 23.248"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path><path d="M23.25 6.748L23.25 0.748 17.25 0.748"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
            ></path><path d="M0.75 17.248L0.75 23.248 6.75 23.248"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
                    ></path><path d="M23.25 0.748L18 5.998"
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                            ></path><path d="M18 17.998L23.25 23.248"
                              fill="none"
                              stroke="currentColor"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                                    ></path><path d="M0.75 6.748L0.75 0.748 6.75 0.748"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                            ></path><path d="M23.25 17.248L23.25 23.248 17.25 23.248"
                                              fill="none"
                                              stroke="currentColor"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                                    ></path><path d="M0.75 0.748L6 5.998"
                                                      fill="none"
                                                      stroke="currentColor"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                            ></path><path d="M8.250 8.248 L15.750 8.248 L15.750 15.748 L8.250 15.748 Z"
                                                              fill="none"
                                                              stroke="currentColor"
                                                              strokeLinecap="round"
                                                              strokeLinejoin="round"
                                                                    ></path></svg>

  )
}
